import React, { Component } from "react";
import { MapContainer, TileLayer, Marker, Popup, MapConsumer } from 'react-leaflet';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import 'leaflet/dist/leaflet.css';
import 'leaflet-geosearch/dist/geosearch.css';
import 'leaflet/dist/leaflet.js';
import L from 'leaflet';

import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import iconSearch from './icon-search.png';
let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconSize: [30, 46],
    iconAnchor: [17, 46]
});

L.Marker.prototype.options.icon = DefaultIcon;

let SearchIcon = L.icon({
  iconUrl: iconSearch,
  iconSize: [30, 30],
  iconAnchor: [10, 20]
});


const provider = new OpenStreetMapProvider({
  params: {
    countrycodes: "py"
  }
});

const searchControl = new GeoSearchControl({
  provider: provider,
  style: 'bar', // optional: bar|button  - default button
  autoComplete : true ,  // opcional: true | false - default true 
  marker: {
    // optional: L.Marker    - default L.Icon.Default
    icon: SearchIcon,
    draggable: false,
  },
  autoCompleteDelay : 250 ,  // opcional: number - default 250 
  showMarker: true, // optional: true|false  - default true
  searchLabel: 'Ingrese calles o referencias(locales, negocios, plazas, iglesias, etc)',
});

var posicion = {
  latitud:0, 
  longitud:0, 
  marca: false
};

var newMarker;
var mapa;
var refMarkerBD;
var ubiProps;
function agregarMarcaUbicacion(lat, lng){
  //// elimina si existe una marca desde la base de datos
  if(refMarkerBD.current!==null){
    mapa.removeLayer(refMarkerBD.current);
  }
  //// elimina si existe una ubicación nueva
  if(newMarker!== undefined){
    mapa.removeLayer(newMarker)
  }   
  //// agrega la ubicacion nueva seleccionada
  newMarker = new L.marker([lat, lng], { DefaultIcon }).addTo(mapa);
  posicion.latitud = lat;
  posicion.longitud = lng;
  posicion.marca=true;
  //// envia la posición al padre
  ubiProps.ubiLatitudLongitud(posicion);
}

export default class MapaUbicacion extends Component {

    constructor(props) {
        super(props);
        refMarkerBD = React.createRef();
        ubiProps = props;
    }
    componentDidMount() {
      this.obtenerUbicacionBD();
    }

    obtenerUbicacionBD(){
      if(this.props.latitud===null || this.props.longitud===null ||
        this.props.latitud===undefined || this.props.longitud===undefined){
        this.obtenerDefault();
      }else{
        posicion.latitud = this.props.latitud;
        posicion.longitud = this.props.longitud;
        posicion.marca = true;
        ubiProps.ubiLatitudLongitud(posicion);
      }
    }

    obtenerDefault(){
      posicion.latitud = -25.2932046;
      posicion.longitud = -57.5764081;
    }

    //// muestra en el mapa el marcador obtenido desde la base de datos
    locationMarker() {
      const position = [posicion.latitud, posicion.longitud];
      return posicion.marca === false ? null : (
        <Marker position={position} ref={refMarkerBD}>
          <Popup>
            <b>{this.props.departamento} - {this.props.barrio}</b>  <br/>
            {this.props.direccion}
          </Popup>
        </Marker>
      )
    }

    render() {
      const position = [posicion.latitud, posicion.longitud];
      return (
        <div>
        {posicion.latitud !== 0 && (
          <MapContainer 
          doubleClickZoom={true}
          center={position} 
          zoom="15" 
          scrollWheelZoom={false} 
          style={{ height: '50vh', width: '50wh' }}>
            <MapConsumer>
              {(map) => {
                mapa = map;
                map.addControl(searchControl);
                map.once("click", function (e) {
                  const { lat, lng } = e.latlng;
                  agregarMarcaUbicacion(lat, lng);
                });
                return null;
              }}
            </MapConsumer>
            <TileLayer
              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {this.locationMarker()}
          </MapContainer>
        )}
        </div>
      );
    }
    
}